import React from "react";
import { Button } from "material-ui";
import { withStyles } from "material-ui/styles";

const styles = theme => {
  return {
    box: {
      width: 980,
      margin: "auto"
    },
    textDiv: {
      float: "left",
      width: 600,
      height: 360,
      display: "flex",
      alignItems: "center",
      justifyContent: "space-around",
      textAlign: "center",
      background: "white",
      border: `10px solid ${theme.palette.answer.borderColor}`
    },
    text: {
      width: 560,
      fontSize: 35,
      lineHeight: "47px",
      wordBreak: "break-word",
      whiteSpace: "pre-wrap"
    },
    buttonDiv: {
      float: "right",
      width: 340
    },
    button: {
      height: 56,
      width: "100%",
      fontSize: 24,
      marginTop: 16
    },
    basicButtonRaised: {
      backgroundColor: theme.palette.answer.main,
      "&:hover": {
        backgroundColor: theme.palette.answer.light,
        // Reset on mouse devices
        "@media (hover: none)": {
          backgroundColor: theme.palette.answer.main
        }
      }
    },
    clear: {
      clear: "both"
    }
  };
};

const ChoiceBtn = props => {
  const { classes, label } = props;

  return (
    <Button
      raised
      className={classes.button}
      classes={{ raised: classes.basicButtonRaised }}
    >
      {label}
    </Button>
  );
};

const QuestionAnswerPanel = props => {
  const { classes, text, choices } = props;

  return (
    <div className={classes.box}>
      <div className={classes.textDiv}>
        <div className={classes.text}>{text}</div>
      </div>

      <div className={classes.buttonDiv}>
        {choices.map(choice => (
          <ChoiceBtn key={choice.id} classes={classes} label={choice.name} />
        ))}
      </div>

      <div className={classes.clear} />
    </div>
  );
};

export default withStyles(styles)(QuestionAnswerPanel);



// WEBPACK FOOTER //
// ./src/components/QuestionAnswerPanel.jsx